import { Typography, Box, makeStyles, Button, Paper, Container, Grid } from "@material-ui/core";
import React from "react";
import {useHistory} from 'react-router-dom'
import RouteConstants from "../../../common/RouteConstants";
import Helper from "../../../common/Helper";


const useStyles = makeStyles((theme) => ({
    content: {
        display: 'flex',
        flexGrow: 1,
        padding: theme.spacing(3),
        background: '#f1f1f1',
        flexDirection: 'column',
        justifyContent: 'space-between'

    },
    contentPaper: {
        height: '100%'
    }
}));

const GuestPromptRegister = () => {
    const classes = useStyles()
    const history=useHistory()

    const handleBackClick=()=>{
        history.push(RouteConstants.OFFICIAL_REGISTRATION)
    }
    return (
        <main className={classes.content}>
            {/* <Toolbar /> */}
            <Box component="main" >
                <Paper square className={classes.contentPaper}>
                    <Container maxWidth="false">
                        <Grid container spacing={2} mt={0}>

                            {/* //{content.map((ques, i) => { */}

                            {/* <Grid item xs={12}>
                                <Typography variant="body1">
                                    {currentQuestion?.questionTitle ?? ''}
                                </Typography>
                            </Grid> */}
                            <Grid item xs={12} style={{ height: 'calc(100vh - 160px)' }}>
                                <Box component='div' display='flex' justifyContent='center' flexDirection='column' height='100%'>
                                    <Box component='div' display='flex' justifyContent='center'>
                                        <Typography variant="subtitle2" color="textPrimary" style={{ fontSize: '1.2rem' }}>To access the full curriculum, please register your account. </Typography>
                                    </Box>
                                    <Box component='div' display='flex' justifyContent='center' mt={1}>
                                        <Button variant="contained" color="primary" onClick={handleBackClick}>Register</Button>
                                    </Box>
                                </Box>
                            </Grid>

                        </Grid>
                    </Container>
                </Paper>
            </Box>
        </main>
    )
}

export default GuestPromptRegister;